import { useContext, useState } from 'react'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import TextField from '@mui/material/TextField'
import styles from './styles.module.css'
import { fetchData } from '../../global/utils/fetch'
import { runRouteOptimizationForLocation, testORTools } from '../api'
import { IRoute } from '../../../../app/entities/Route'
import { ToastNotificationContext } from '../../global/context/toast-context/ToastNotificationContext'
import { CircularProgress } from '@mui/material'

export default function RouteOptimizationCorrector() {
  const [form, setForm] = useState({
    date: '',
    locationObjectId: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)

  const handleRunROForLocation = async () => {
    const { date: dateString, locationObjectId } = form
    if (!dateString) return alert('Please select a date')
    const date = new Date(dateString)
    try {
      setIsLoading(true)
      const now = new Date()
      const res = await fetchData<IRoute[]>(
        runRouteOptimizationForLocation(
          date,
          locationObjectId.length ? locationObjectId : undefined,
        ),
      )
      const timeElapsed = (date.getTime() - now.getTime()) / 1000
      setIsLoading(false)
      console.log(res)
      setToastStatus({
        ...toastStatus,
        message: `Route optimization for ${
          new Date(date).toISOString().split('T')[0]
        } completed successfully in ${timeElapsed} sec`,
        severity: 'success',
        isOpen: true,
      })
    } catch (error) {
      console.error(error)
      setToastStatus({
        ...toastStatus,
        message: `Error running route optimization for ${
          new Date(date).toISOString().split('T')[0]
        }: ${error instanceof Error ? error.message : 'Unknown error'}`,
        severity: 'error',
        isOpen: true,
      })
    }
  }

  async function handleTestORTools() {
    const { date, locationObjectId } = form
    if (!date || !locationObjectId)
      return alert('Please select a date and location')

    try {
      const res = await fetchData<IRoute[]>(
        testORTools({
          locationId: locationObjectId,
          date: new Date(date).setUTCHours(0, 0, 0, 0).valueOf(),
        }),
      )
      console.log(res)
      alert('Ran OR tools test')
    } catch (error) {
      console.error(error)
      alert('Error running test for OR tools')
    }
  }

  return (
    <div>
      <h2>Routing Stuff</h2>
      <div className={styles.inputsContainer}>
        <LocationDropDown
          onLocationChange={(locationObjectId: any) =>
            setForm({ ...form, locationObjectId })
          }
        />
        <TextField
          type='date'
          label='Date'
          name='date'
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <PrimaryButton
          buttonName='Run RO for location'
          onClick={handleRunROForLocation}
          disabled={isLoading}
        >
          <>
            {isLoading && (
              <div style={{ marginRight: '12px' }}>
                <CircularProgress size={20} />
              </div>
            )}
            {'Run RO for location'}
          </>
        </PrimaryButton>

        <PrimaryButton
          buttonName='Test OR Tools'
          onClick={handleTestORTools}
        />
      </div>
    </div>
  )
}
